import * as React from 'react';
import { Button, Form, Header, Image, Segment, GridRow } from 'semantic-ui-react';

import configs from '../helpers/config';
import LinkButton from './LinkButton';

class LoginPaciente extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...configs.DEFAULT_PACIENTE };
    }

    handleLogin() {
        const { chave, date } = this.state;

        if (chave && date) {
            this.props.onClick({ ...this.state });
            this.setState({ ...configs.DEFAULT_PACIENTE });
        } else {
            alert('Insira a os dados de acesso corretamente');
        }
    }

    handleEmail = (e) => {
        const email = e.target.value.indexOf('@') > 0;
        this.setState({ email, chave: e.target.value })
    }

    handleData = (e) => {
        let value = e.target.value;

        if (!this.state.email) {
            value = (e.target.value.replace(/\D+/, ''))
                .substr(0, 8)
                .replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
        }

        this.setState({ date: value });
    }

    render() {
        return (
            <Segment className={this.props.className}>
                <Header as='h2'  >
                    <p className='headerLogin' ><Image src={require('../img/paciente.png')} size='small' verticalAlign='middle' className='imgLogoLogin' />BENEFICIÁRIO</p>
                </Header>
                <Form size='large'>
                    <GridRow >
                        <Form.Input
                            fluid
                            icon={this.state.email ? 'at' : 'user'}
                            iconPosition='left'
                            placeholder='Chave de acesso ou email'
                            value={this.state.chave}
                            onChange={this.handleEmail}
                        />
                        <Form.Input
                            type={this.state.email ? 'password' : 'text'}
                            fluid
                            iconPosition='left'
                            icon={this.state.email ? 'lock' : 'calendar'}
                            placeholder="Data de nascimento ou senha"
                            value={this.state.date}
                            onChange={this.handleData} />

                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            CONSULTAR RESULTADOS
                    </Button >
                        <br />
                        <LinkButton onClick={this.props.recuperar} >Esqueci minha senha</LinkButton>
                    </GridRow>
                </Form>
            </Segment>
        );
    }
}
export default LoginPaciente;
